import { addLike, addToFav } from "Actions";
import { saveLike as saveApiLike, saveFavorite } from "Api";

export const saveLike = ({ id, isLike, type } = {}) => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;

  return dispatch(
    addLike(
      saveApiLike({
        objectId: id,
        isLike,
        organizationId: navCommunity.id,
        objectType: type,
        token
      })
    )
  );
};

export const addToFavorite = ({ id, objectType }) => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;

  return dispatch(
    addToFav(
      saveFavorite({
        token,
        objectId: id,
        objectType,
        organizationId: navCommunity.id
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/social.js